import { gsap } from 'gsap';

export default function initializeMobileMenu() {
    const menuItems = document.querySelectorAll('.mobile-menu .menu__item');
    const menuToggles = document.querySelectorAll('.menu-toggle, .menu-toggle-close');
    const mobileMenu = document.getElementById('mobile-menu');
    const body = document.body;

    let isMenuOpen = false;
    gsap.set(mobileMenu, { x: '100%' });

    function closeAllSubmenus() {
        menuItems.forEach(item => {
            const submenu = item.querySelector('.menu--submenu');
            if (submenu && item.classList.contains('open')) {
                closeSubmenu(item, submenu);
            }
        });
    }

    function closeSubmenu(item, submenu) {
        gsap.to(submenu, {
            height: 0,
            opacity: 0,
            duration: 0.2,
            ease: 'power2.inOut',
            onComplete: () => {
                submenu.style.display = 'none';
            }
        });
        item.classList.remove('open');
    }

    menuToggles.forEach(toggle => {
        toggle.addEventListener('click', function (e) {
            e.stopPropagation();

            if (isMenuOpen) {
                closeAllSubmenus();
                gsap.to(mobileMenu, { x: '100%', duration: 0.2, ease: 'power2.inOut' });
                body.classList.remove('no-scroll');
                isMenuOpen = false;
            } else {
                gsap.to(mobileMenu, { x: '0%', duration: 0.2, ease: 'power2.inOut' });
                body.classList.add('no-scroll');
                isMenuOpen = true;
            }
        });
    });

    document.addEventListener('click', function (e) {
        if (!mobileMenu.contains(e.target) && isMenuOpen) {
            closeAllSubmenus();
            gsap.to(mobileMenu, { x: '100%', duration: 0.2, ease: 'power2.inOut' });
            body.classList.remove('no-scroll');
            isMenuOpen = false;
        }
    });

    menuItems.forEach(item => {
        const submenu = item.querySelector('.menu--submenu');

        if (submenu) {
            gsap.set(submenu, { height: 0, opacity: 0, display: 'none' });

            item.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();

                const isOpen = item.classList.contains('open');

                if (isOpen) {
                    closeSubmenu(item, submenu);
                } else {
                    const siblingItems = item.parentElement.querySelectorAll('.menu__item.open');
                    siblingItems.forEach(sibling => {
                        const siblingSubmenu = sibling.querySelector('.menu--submenu');
                        if (siblingSubmenu) {
                            closeSubmenu(sibling, siblingSubmenu);
                        }
                    });

                    submenu.style.display = 'block';
                    gsap.fromTo(submenu,
                        { height: 0, opacity: 0 },
                        { height: 'auto', opacity: 1, duration: 0.2, ease: 'power2.inOut' }
                    );
                    item.classList.add('open');
                }
            });
        }
    });
}
